var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-09-13
 * @brief SEI 운영관리 -SiteInfoView 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, curAdminTreeState } from "../../../../../recoil/assessmentState";
import { reLoad, reLoadPage, userInfoLoginState } from "../../../../../recoil/userState";
// utils
import dayjs from "dayjs";
import { langId } from "../../../../../recoil/langState";
import { loadingBoxState } from "../../../../../recoil/menuState";
import * as CONST from "../../../../../utils/Const";
import * as HTTPUTIL from "../../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../../utils/commUtils";
import { useTrans } from "../../../../../utils/langs/useTrans";
function SiteRoom(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTree = useRecoilValue(curAdminTreeState);
    const reload = useRecoilValue(reLoad);
    const langIds = useRecoilValue(langId);
    // props
    const { handleOpenPop, onClickTab, isMobile } = props;
    //
    const [roomInfo, setRoomInfo] = useState(null);
    const [roomItem, setRoomItem] = useState(null);
    const [popreset, setPopreset] = useState(false);
    useEffect(() => {
        // 등록
        handleOpenPop("pop-add-info", _jsx(DeviceAddPop, { popreset: popreset, setPopreset: setPopreset, onClickTab: onClickTab, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.추가") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-add-info") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        //분전소 등록
        handleOpenPop("pop-add-detail-edit", _jsx(RoomAddEdit, { roomItem: roomItem, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.수정") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-add-detail-edit") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, {}));
    }, [popreset, roomItem]);
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
        setPopreset(true);
    }
    // 기본 주소
    let appPath = `?roomId=${recoilTree.room.roomId}`;
    // 사업장 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/room/detail${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setRoomInfo(data.body);
            }
        }
    }, [data, reload, langIds]);
    function onClickFiles(item) {
        HTTPUTIL.fileDownload(item.name, item.url);
    }
    function Edit(e) {
        setRoomItem(roomInfo);
        CUTIL.jsopen_Popup(e);
    }
    function RoomGo(e) {
        onClickTab("DEVICE");
    }
    return (_jsx(_Fragment, { children: roomInfo && (_jsxs("div", Object.assign({ className: "box__body", style: { paddingTop: isMobile ? "59px" : "24px" } }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: _jsxs("div", Object.assign({ className: "top-button" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn btn-edit blue js-open", "data-pop": "pop-add-detail-edit", onClick: (e) => Edit(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete blue js-open", "data-pop": "pop-delete", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] })) })) })), _jsxs("div", Object.assign({ className: "content__info" }, { children: [_jsx("h3", Object.assign({ className: "hide" }, { children: "\uBD84\uC804\uC18C \uC815\uBCF4" })), _jsxs("ul", Object.assign({ className: "form__info" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.분전소명") })), _jsx("p", Object.assign({ className: "txt" }, { children: roomInfo.roomName }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.전기실도면") })), _jsx("p", Object.assign({ className: "txt" }, { children: _jsx("span", Object.assign({ className: "filelist" }, { children: roomInfo.fileList.length > 0 &&
                                                    roomInfo.fileList.map((item, idx) => (_jsx("span", Object.assign({ onClick: (e) => onClickFiles(item) }, { children: _jsx("span", { children: item.name }) }), "files_" + idx.toString()))) })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.운영설비") })), _jsx("p", Object.assign({ className: "txt" }, { children: roomInfo.itemCount }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.메모") })), _jsx("p", Object.assign({ className: "txt" }, { children: !roomInfo.memo ? "-" : roomInfo.memo }))] })] }))] })), _jsxs("div", Object.assign({ className: "content__info line" }, { children: [_jsx("div", Object.assign({ className: "top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.운영설비현황") })) })), _jsxs("ul", Object.assign({ className: "box-small-wrap link" }, { children: [roomInfo.spgs.map((item, idx) => (_jsxs("li", Object.assign({ onClick: (e) => RoomGo(e), style: { cursor: "pointer" } }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: item.spgName })), _jsx("p", Object.assign({ className: "count-info" }, { children: _jsxs("span", { children: [_jsx("strong", { children: item.itemCount }), "ea"] }) }))] }), "subroomManageList_" + idx.toString()))), _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-add js-open", "data-pop": "pop-add-info", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.설비추가") })) })) })] }))] }))] }))) }));
}
export default SiteRoom;
function DeviceAddPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [reload, setReload] = useRecoilState(reLoad);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const langIds = useRecoilValue(langId);
    //props
    const { popreset, setPopreset, onClickTab } = props;
    // useState
    const [spgInfo, setSpgInfo] = useState([]);
    const [spg, setSpg] = useState(null);
    const [elecInfo, setEleInfo] = useState([]);
    const [itemName, setItemName] = useState("");
    const [panelName, setPanelName] = useState("");
    const [serialNo, setSerialNo] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [memo, setMemo] = useState("");
    const [today, setToday] = useState("");
    const [errorList, setErrorList] = useState([]);
    const [file, setFile] = useState([]);
    const lastNum = 10;
    // spg select
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/company/${recoilTree.company.companyId}/spgs`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: recoilTree.subZone.subZoneId + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSpgInfo(data.body);
                if (popreset) {
                    PopClose("pop-add-info");
                    setPopreset(false);
                }
            }
            else {
                // need error handle
            }
        }
    }, [data, popreset, langIds]);
    // spg select 후 전력 정보 추출
    function onClickSpg(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${item.companySpgId}/elecinfos`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setEleInfo(data.body.map((item) => (Object.assign(Object.assign({}, item), { value: "" }))));
                    setSpg(item);
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    function PopClose(id) {
        CUTIL.jsclose_Popup(id);
        setSpg(null);
        setItemName("");
        setPanelName("");
        setSerialNo("");
        setManufacturer("");
        setMemo("");
        setToday("");
        setEleInfo([]);
        setFile([]);
    }
    // 전력정보 등록
    function ElecIfoChange(e, id) {
        setEleInfo(elecInfo.map((smenu) => (smenu.companyElecId === id ? Object.assign(Object.assign({}, smenu), { value: e.target.value }) : smenu)));
    }
    function onChangeItem(e) {
        setErrorList(errorList.filter((err) => err.field !== "itemName"));
        setItemName(e.target.value);
    }
    function onChangePanel(e) {
        setErrorList(errorList.filter((err) => err.field !== "panelName"));
        setPanelName(e.target.value);
    }
    function onChangeSerialNo(e) {
        setErrorList(errorList.filter((err) => err.field !== "serialNo"));
        setSerialNo(e.target.value);
    }
    function onChangeManufacturer(e) {
        setErrorList(errorList.filter((err) => err.field !== "manufacturer"));
        setManufacturer(e.target.value);
    }
    function onChangeTodayMonth(e) {
        setErrorList(errorList.filter((err) => err.field !== "madeyyyyMM"));
        if (e.target.value.length <= 7) {
            setToday(e.target.value);
        }
    }
    function itemAddClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            let itemArr = [];
            for (let i = 0; i < elecInfo.length; i++) {
                itemArr.push({
                    elecCode: elecInfo[i].code,
                    value: elecInfo[i].value,
                });
            }
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/product/item`,
                appQuery: {
                    roomId: recoilTree.room.roomId,
                    spgName: spg ? spg.spgName : "",
                    itemName: itemName,
                    panelName: panelName,
                    serialNo: serialNo,
                    manufacturer: manufacturer,
                    madeyyyyMM: dayjs(today).format("YYYYMM").toString(),
                    elecInfo: itemArr,
                    memo: memo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (file.length > 0) {
                        uploadFileImage(data.body.itemIdPk);
                    }
                    else {
                        setReload(true);
                        PopClose("pop-add-info");
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.기기가등록되었습니다") }));
                        onClickTab("DEVICE");
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
                else {
                    // need error handle
                    setErrorList(data.errorList);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(index) {
        setFile(file.filter((_, idx) => idx !== index));
    }
    // 첨부파일 업로드
    function uploadFileImage(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let appPath = `?itemId=${itemId}`;
            const formData = new FormData();
            // 파일 데이터 저장
            file.map((files) => formData.append("files", files));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/images/item${appPath}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setFile([]);
                    setReload(true);
                    PopClose("pop-add-info");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-info", type: CONST.TYPE_INNRE, divTag: t("라벨.기기가등록되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-info");
                    onClickTab("DEVICE");
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                        setErrorList(data.errorList);
                        setRecoilIsLoadingBox(false);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function AddClose(id) {
        CUTIL.jsclose_Popup(id);
        // setCheckEdit(null);
        // setCheckChange(false);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body pb-0" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: recoilTree.company.companyName + " " + recoilTree.zone.zoneName }), _jsx("li", { children: recoilTree.subZone.subZoneName }), _jsx("li", { children: recoilTree.room.roomId ? recoilTree.room.roomName : t("라벨.전체") })] })), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [_jsx("h2", { children: t("라벨.설비정보") }), _jsxs("ul", Object.assign({ className: "form__input scrollH h440 pb-30" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.분전소명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp26", value: recoilTree.room.roomName, readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select spg ${errorList.filter((err) => err.field === "companyId").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !spg ? t("라벨.클릭선택") : spg.spgName })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: spgInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg(info) }, { children: info.spgName }), "spgInfos_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${spg && spg.spgName == "배전반" ? "" : "star"}` }, { children: t("라벨.형명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { className: `${errorList.filter((err) => err.field === "itemName").length > 0 ? " input-error" : ""}`, type: "text", id: "inp22", placeholder: spg && spg.spgName == "배전반" ? "" : t("라벨.텍스트입력"), value: itemName, onChange: (e) => onChangeItem(e), disabled: spg && spg.spgName == "배전반" ? true : false }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "itemName").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${spg && (spg.spgName == "GIS" || spg.spgName == "유입식TR") ? "" : "star"}` }, { children: t("라벨.판넬명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "panelName").length > 0 ? " input-error" : ""}`, type: "text", id: "inp23", placeholder: spg && (spg.spgName == "GIS" || spg.spgName == "유입식TR") ? "" : t("라벨.텍스트입력"), value: panelName, onChange: (e) => onChangePanel(e), disabled: spg && (spg.spgName == "GIS" || spg.spgName == "유입식TR") ? true : false }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "panelName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${spg && spg.spgName == "배전반" ? "" : "star"}` }, { children: t("라벨.시리얼번호") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "serialNo").length > 0 ? " input-error" : ""}`, type: "text", id: "inp24", placeholder: t("라벨.텍스트입력"), value: serialNo, onChange: (e) => onChangeSerialNo(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "serialNo").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제조사") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "manufacturer").length > 0 ? " input-error" : ""}`, type: "text", id: "inp25", placeholder: t("라벨.텍스트입력"), value: manufacturer, onChange: (e) => onChangeManufacturer(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "manufacturer").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.제조년월") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "madeyyyyMM").length > 0 ? " input-error" : ""}`, type: "text", id: "inp28", placeholder: t("라벨.제조년월입력"), value: today.toString().replace(/(\d{4})(\d{1})/, "$1-$2"), onChange: (e) => onChangeTodayMonth(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "madeyyyyMM").map((err) => err.msg) }))] }))] }), elecInfo.map((item, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit mt-0" }, { children: [langIds > 1 ? item.elecInfoNameEnglish : item.elecInfoName, " (", item.unit, ")", _jsx("br", {}), _jsxs("span", Object.assign({ className: "fontRegular" }, { children: ["(", item.code, ")"] }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp_" + idx, value: item.value, onChange: (e) => ElecIfoChange(e, item.companyElecId) }) }))] }, "lsinfoEdit_" + idx.toString()))), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: _jsx("span", { children: t("라벨.첨부파일") }) })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.사진첨부하세요"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file2" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", accept: "image/*", id: "file2", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부120MB") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: file.map((img, idx) => (_jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "imgsEdit_" + idx.toString()))) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit " }, { children: t("라벨.메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [memo ? memo.length : "0", " / 400"] }))] }))] })] }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => PopClose("pop-add-info") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => itemAddClick(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function RoomAddEdit(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reloadPages, setReloadPages] = useRecoilState(reLoadPage);
    const { roomItem } = props;
    //
    const [errorList, setErrorList] = useState([]);
    const [roomName, setRoomName] = useState("");
    const [memo, setMemo] = useState("");
    const [fileT, setFileT] = useState([]);
    const lastNum = 10;
    useEffect(() => {
        if (roomItem) {
            setRoomName(roomItem.roomName);
            setFileT(roomItem.fileList);
            setMemo(roomItem.memo);
        }
    }, [roomItem]);
    function onChangeRoom(e) {
        setRoomName(e.target.value);
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...fileT];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFileT(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(index, item) {
        if (item.imageId) {
            FileDelete(item, index);
        }
        else {
            setFileT(fileT.filter((_, idx) => idx !== index));
        }
    }
    function FileDelete(img, index) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/image/${img.imageId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.body }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setFileT(fileT.filter((_, idx) => idx !== index));
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    function RoomEdit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/product/room/${recoilTree.room.roomId}`,
                appQuery: {
                    roomName: roomName,
                    memo: memo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (fileT.filter((img) => img.type).length > 0) {
                        uploadFileImage(data.body);
                    }
                    else {
                        setRecoilTree(Object.assign(Object.assign({}, recoilTree), { room: { roomId: data.body.roomId, roomName: data.body.roomName } }));
                        setReloadPages(true);
                        setReload(true);
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.수정되었습니다") }));
                        CUTIL.jsclose_Popup("pop-add-detail-edit");
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setReloadPages(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
                else {
                    // need error handle
                    if (data.errorList !== null) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: CONST.ERROR_MSG }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    setErrorList;
    // 첨부파일 업로드
    function uploadFileImage(room) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let appPath = `?roomId=${room.roomId}`;
            const formData = new FormData();
            // 파일 데이터 저장
            fileT.map((files) => formData.append("files", files));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/images/room${appPath}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setRecoilTree(Object.assign(Object.assign({}, recoilTree), { room: { roomId: room.roomId, roomName: room.roomName } }));
                    setReloadPages(true);
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.수정되었습니다") }));
                    CUTIL.jsclose_Popup("pop-add-detail-edit");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setReloadPages(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.오류로인하여첨부파일이제거되어분전소만수정되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: recoilTree.zone.zoneName }), _jsx("li", { children: recoilTree.subZone.subZoneName }), _jsx("li", { children: t("라벨.전체") })] })), _jsx("h2", Object.assign({ className: "mt-32" }, { children: t("라벨.신규분전소등록") })), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.명칭") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: t("라벨.분전소입력"), value: roomName, onChange: (e) => onChangeRoom(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.전기실도면") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.클릭등록"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file3" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file3", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부120MB") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: fileT.map((img, idx) => (_jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(idx, img) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "imgsEdit_" + idx.toString()))) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h74", placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-add-detail-edit") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => RoomEdit(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { checkArr, setCheckArr } = props;
    function Delete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/product/usertree?productId=${recoilTree.room.roomId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.jsclose_Popup("pop-delete");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.삭제되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsclose_Popup("pop-delete");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.분전소를삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            Delete(e);
                        } }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
